export const normalizeAlias = (str: string) =>
    str === '/' ? '/' : str.replace(/^\/|\/$/g, '');

const STORAGE_KEY = 'hh_snow_enabled';

export const getIsSnowEnabled = (): boolean => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        return saved == null ? true : saved === '1';
    } catch (e) {
        return true;
    }
};

export const setIsSnowEnabled = (value: boolean): void => {
    try {
        localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
    } catch (e) {
        // ignore
    }
};

export const toggleSnowEnabled = (currentValue: boolean): boolean => {
    const nextValue = !currentValue;
    setIsSnowEnabled(nextValue);
    return nextValue;
};

export const isWinterMonth = (date = new Date()): boolean => {
    const month = date.getMonth(); // 0 = Jan, 11 = Dec
    return month === 11 || month === 0 || month === 1;
};
